import { action } from 'satcheljs';
import { ClientItemId } from 'owa-client-ids';

export const clickAgendaEvent = action(
    'clickAgendaEvent',
    (id: ClientItemId, target: any, scenarioId: string) => ({
        id,
        target,
        scenarioId,
    })
);

export const doubleClickAgendaEvent = action(
    'doubleClickAgendaEvent',
    (id: ClientItemId, target: any, scenarioId: string) => ({
        id,
        target,
        scenarioId,
    })
);

export const rightClickAgendaEvent = action(
    'rightClickAgendaEvent',
    (id: ClientItemId, parentFolderId: string, evt: any, scenarioId: string) => ({
        id,
        parentFolderId,
        evt,
        scenarioId,
    })
);

export const updateSelectedCalendarEvent = action(
    'updateSelectedCalendarEvent',
    (selectedCalendarEventId: string, scenarioId: string) => ({
        selectedCalendarEventId,
        scenarioId,
    })
);
